import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Dialog,
  DialogFooter,
  DialogType,
  MessageBar,
  IMessageBarStyles,
  PrimaryButton,
  Stack,
  Text,
} from "@fluentui/react";

import { useAppSelector } from "../../hooks/redux";
import type { RootState } from "../../store";

type NotificationDetails = RootState["notification"]["notificationDetails"];

export const NotificationPopup = () => {
  const { pathname } = useLocation();
  const notificationDetails = useAppSelector(
    (state) => state.notification.notificationDetails
  );
  const actionDialogVisible = useAppSelector((state) => state.dialog.visible);
  const seenNotifications = useRef(new WeakSet<NotificationDetails[number]>());
  const [pendingNotifications, setPendingNotifications] =
    useState<NotificationDetails>([]);

  useEffect(() => {
    const newNotifications = notificationDetails.filter(
      (notification) =>
        !seenNotifications.current.has(notification) &&
        new RegExp(notification.sourcePageURL, "i").test(pathname)
    );

    newNotifications.forEach((notification) =>
      seenNotifications.current.add(notification)
    );
    if (newNotifications.length > 0) {
      // Keep messages available after the banner's automatic cleanup.
      setPendingNotifications((pending) => [...pending, ...newNotifications]);
    }
  }, [notificationDetails, pathname]);

  const dismiss = () => setPendingNotifications([]);

  return (
    <Dialog
      hidden={pendingNotifications.length === 0 || actionDialogVisible}
      onDismiss={dismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title: "Information",
        showCloseButton: false,
      }}
      modalProps={{ isBlocking: true }}
    >
      <Stack tokens={{ childrenGap: 8 }}>
        {pendingNotifications.map((notification, index) => (
          <Text key={index} block>{notification.message}</Text>
        ))}
      </Stack>
      <DialogFooter>
        <PrimaryButton text="OK" onClick={dismiss} />
      </DialogFooter>
    </Dialog>
  );
};

export const Notification: React.FC = () => {
  const location = useLocation();
  const notificationDetails = useAppSelector(
    (state) => state.notification.notificationDetails
  );
  return (
    <>
    {notificationDetails &&
    notificationDetails.length > 0 &&
    notificationDetails.map((notification, index) => {
      return (
        (new RegExp(notification.sourcePageURL, 'i').test(location.pathname)) && (
          <MessageBar
            key={location.pathname+"_"+Math.random()}
            messageBarType={notification.type}
            isMultiline={true}
            styles={notificationStype}
          >
            {notification.message}
          </MessageBar>
        )
      );
    })}
    </>
  );
};

const notificationStype: Partial<IMessageBarStyles> = {
  icon: {
    fontSize: "20px",
  },
  innerText: {
    fontSize: "15px",
    lineHeight: "20px",
  },
  root: {
    marginBottom: "10px",
  },
};
